"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBlockedSteps = getBlockedSteps;
const getState_1 = require("./getState");
const dist_1 = require("../../core/dist");
/**
 * List all blocked steps across all implementing plans. A step is blocked when its
 * "Blocked by" dependencies are not yet satisfied.
 *
 * Single source of truth for blocked-step listing: both the `loom_get_blocked_steps`
 * MCP tool and the `loom blocked` CLI command call this use-case.
 */
async function getBlockedSteps(deps) {
    const state = await (0, getState_1.getState)(deps);
    const index = state.index;
    const blocked = [];
    for (const weave of state.weaves) {
        for (const thread of weave.threads) {
            for (const plan of thread.plans) {
                if (plan.status !== 'implementing')
                    continue;
                for (const step of plan.steps ?? []) {
                    if (step.status === 'done' || step.status === 'cancelled')
                        continue;
                    if ((0, dist_1.isStepBlocked)(step, plan, index)) {
                        blocked.push({
                            planId: plan.id,
                            weaveSlug: weave.id,
                            threadSlug: thread.id,
                            stepId: step.id,
                            stepNumber: step.order,
                            stepDescription: step.description,
                            blockedBy: step.blockedBy ?? [],
                        });
                    }
                }
            }
        }
    }
    return blocked;
}
